import '@Global/modal';
import {createRoot} from 'react-dom/client';
import App from '@Components/app';
import {CreateWithAiPromptBox} from '@Components/create-with-ai-prompt-box/create-with-ai-prompt-box';
import {AICHAT_MARKETING_PROMPT_BOX_ID} from '@Components/mystuff-hero/components/mystuff-prompt-box/mystuff-prompt-box.library';
import {AiChatSource} from '@Components/ai-chat-window/ai-chat-window.types';
import {AiChatStartSource} from '@Libraries/ga-events';

const container = document.getElementById('marketing-ai-chat-prompt-box');
if (container) {
  const root = createRoot(container);
  root.render(
    <App>
      <div style={{maxWidth: 780, margin: '0 auto', zIndex: 1000, position: 'relative'}} className="_full-width spacing-m-b-6">
        <CreateWithAiPromptBox promptBoxId={AICHAT_MARKETING_PROMPT_BOX_ID} chatSource={AiChatSource.AI_MARKETING_PAGE} startSource={AiChatStartSource.AI_MARKETING_PAGE} />
      </div>
    </App>
  );
}
